<template>
    <img :src="$icons[type]" />
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// icon.vue?65a7b362